import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import Helmet from 'react-helmet';

import connect from '../../utils/connect';

import { awardsRoute } from '../../routes';
import baseURL from '../../utils/baseUrl';

import InfiniteScroll from '../../utils/infiniteScroll';

import * as TimelineActions from '../../actions/timelines';
import * as CategoryActions from '../../actions/categories';

import TimelineDisplay from '../../components/timeline/display';

import Spinner from '../../components/svg/spinner';

import {
	STATE_ALL_ON
} from '../../constants/states';

class Timeline extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
		timelines: PropTypes.object.isRequired,
	};

	constructor(props) {
		super();
		this.contentUpdate = 0;

		this.state = {
			contentTop: 0,
			contentHeight: 0,
			timelineActions: bindActionCreators(TimelineActions, props.dispatch),
			categoryActions: bindActionCreators(CategoryActions, props.dispatch),
			page: 0,
		};

		this.buttonHoverTimer = {
			timer: null,
			startTime: 0
		}

		this.timelineUpdate = undefined;
	}

	componentWillMount() {
		if (this.state.timelineActions && typeof this.state.timelineActions.fetchTimeline === 'function') {
			let params = {
				limit: 20,
				offset: 0,
			};

			if (this.props.router.params.pageNum) {
				this.state.initPage = parseInt(this.props.router.params.pageNum, 10);
				params.offset = (this.props.router.params.pageNum - 1) * 20;
			}

			this.state.timelineActions.fetchTimeline(params);
		}

		if (this.state.categoryActions && typeof this.state.categoryActions.fetchCategories === 'function') {
			this.state.categoryActions.fetchCategories();
		}

		this.setState(this.state);
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			(this.props.browser && this.props.browser.window && nextProps.browser.window.width !== this.props.browser.window.width) ||
			(this.props.timelines.update !== nextProps.timelines.update) ||
			(this.dimensionsChanged) ||
			(this.state.page !== nextState.page)
		);
	}

	componentDidMount() {
		this.updateStateIfDimensionsChanged(this.props, this.state);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.timelines.update !== this.timelineUpdate) {
			this.timelineUpdate = this.props.timelines.update;
			this.updateStateIfDimensionsChanged(this.props, this.state);
		}
	}

	render() {
		let { items, next, prev, filter, isFetching, skip, startPage } = this.props.timelines;
		let { fetchTimeline } = this.state.timelineActions;
		let content = false;

		if (this.refs.timelinedisplay && this.refs.timelinedisplay.refs && this.refs.timelinedisplay.refs.container) {
			content = this.refs.timelinedisplay.refs.container;
		}

		return (
			<div>
				<InfiniteScroll
					dispatch={this.props.dispatch}
					next={next}
					prev={prev}
					browser={this.props.browser}
					contentHeight={this.state.contentHeight}
					contentTop={this.state.contentTop}
					update={this.props.timelines.update}
					isFetching={this.props.timelines.isFetching}
					fetch={(url, direction) => {
						return fetchTimeline({}, url, direction);
					}}
					pageUrl={awardsRoute()}
					pageCount={items.length / 21}
					page={this.state.page}
					initPage={this.state.initPage}
					hasPushState={(!this.props.timelines.filters || this.props.timelines.filters === STATE_ALL_ON)}
					triggerElement={this.getTriggerElement.bind(this)()}
					disableManualTrigger={(!!this.props.timelines.prev || this.props.timelines.items > 20)}
				>
					<Helmet title='The FWA - Awards' />
					{items && !items.length && (
						<Spinner className='timeline__spinner' size='80px'/>
					)}
					<TimelineDisplay ref='timelinedisplay' items={items} skip={skip} startPage={startPage} hasPushState={(!this.props.timelines.filters || this.props.timelines.filters === STATE_ALL_ON)} browser={this.props.browser} updatePushState={this.triggerPushStateUpdate.bind(this)}  />
				</InfiniteScroll>
			</div>
		);
	}

	getTriggerElement() {
		return (
			<div className='timeline__infinite-trigger span2 span6-mobile pixel-pattern pixel-pattern--10'>
				<div>
					Load more
				</div>
				<div className="arrow-container">
					<span></span>
				</div>
			</div>
		);
	}

	triggerPushStateUpdate(page) {
		this.setState({...this.state, page: page});
	}

	getDimensions(props) {
		let timelineElement = document.querySelector('ul.timeline');
		let dimensions = {
			contentTop: 0,
			contentHeight: 0,
		};

		if (timelineElement) {
			dimensions.contentTop = timelineElement.offsetTop;
			dimensions.contentHeight = timelineElement.offsetHeight;

			// console.log(`%c TIMELINE: - update#: ${props.timelines.update} - height: ${this.state.contentHeight}`, 'background-color: black;color: white;');
		}

		return dimensions;
	}

	updateStateIfDimensionsChanged(props, state) {
		let dim = this.getDimensions(props);
		this.dimensionsChanged = false;

		if (state.contentHeight !== dim.contentHeight) {
			this.dimensionsChanged = true;

			state.contentTop = dim.contentTop;
			state.contentHeight = dim.contentHeight;

			//triger re-render with correct dimensions
			this.setState(state);
		}
	}
}

export default connect(Timeline);



/** WEBPACK FOOTER **
 ** ./frontend/containers/timeline/timeline.js
 **/